export const apiCreate = (): string => '/commercial/hirings/create'
export const apiCreatePerImport = (): string =>
  '/commercial/hirings/createPerImport'
export const apiList = (id?: string): string =>
  !id ? '/commercial/hirings/' : `/commercial/hirings/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/hirings/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/hirings/delete/${id}`
